import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { DefaultProviders } from './components/DefaultProviders';
import { DEFAULT_RENDER_ELEMENT_ID } from './const';

// Logování
/*
const appConfig: ReactAppParams = window.appConfig;
if (appConfig && appConfig.sentry && (!__DEV__ || appConfig.sentry.force)) {
  let url =
    window.location.protocol +
    '//' +
    window.location.host +
    appConfig.serverContextPath +
    '/log';
  let options = { release: appConfig.version + (appConfig.buildNumber || '') };
  if (appConfig.sentry) {
    if (appConfig.sentry.url) {
      url = appConfig.sentry.url;
    }
    if (appConfig.sentry.options) {
      options = { ...appConfig.sentry.options, ...options };
    }
  }
}*/

export function render(
  app: React.ReactElement,
  elementId = DEFAULT_RENDER_ELEMENT_ID
) {
  ReactDOM.render(app, document.getElementById(elementId));
}

export function renderWithDefaultProviders(app: React.ReactElement) {
  render(<DefaultProviders>{app}</DefaultProviders>);
}
/**
render(
  <ThemeProvider value={x}>
    <AppComponent />
  </ThemeProvider>
);
render(
  <DefaultProviders queryClientConfig={{}}>
    <App />
  </DefaultProviders>
);

renderWithDefaultProviders(<AppComponent />);
 */
/* TODO
renderWithDefaultProviders(
  <ServerStorageProvider>
    <AppComponent />
  </ServerStorageProvider>
);
*/
